import CssBaseline from "@mui/material/CssBaseline";
import AppProviders from "./context/app-providers";
import Routes from "./routes/routes";
import SidebarLayout from "./components/sidebar/sidebar-layout";

const App: React.FC = () => {
  return (
    <AppProviders>
      <CssBaseline />
      <SidebarLayout>
        <Routes />
      </SidebarLayout>
    </AppProviders>
  );
};

export default App;
